import React, { useRef, useEffect } from 'react';
import gsap from 'gsap';
import './Mappage.css';
import AsteriskNav from './Asterisknav';

const MapPage = () => {
    const navRef = useRef(null);
    const sheetRef = useRef(null);
    const locationCardRef = useRef(null);
    const contactRowRef = useRef(null);
    const btnsRowRef = useRef(null);
    const infoCardRef = useRef(null);
    const mapEmbedRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

        gsap.set(navRef.current, { opacity: 0, y: -40 });
        gsap.set(sheetRef.current, { opacity: 0, y: 50, scale: 0.97 });
        gsap.set(locationCardRef.current, { opacity: 0, x: -30 });
        gsap.set(contactRowRef.current, { opacity: 0, y: 16 });
        gsap.set(btnsRowRef.current, { opacity: 0, y: 20, scale: 0.95 });
        gsap.set(infoCardRef.current, { opacity: 0, y: 30 });
        gsap.set(mapEmbedRef.current, { opacity: 0, y: 30 });

        tl.to(navRef.current, { opacity: 1, y: 0, duration: 0.8 })
          .to(sheetRef.current, { opacity: 1, y: 0, scale: 1, duration: 0.7 }, '-=0.4')
          .to(locationCardRef.current, { opacity: 1, x: 0, duration: 0.6 }, '-=0.3')
          .to(contactRowRef.current, { opacity: 1, y: 0, duration: 0.5 }, '-=0.3')
          .to(btnsRowRef.current, { opacity: 1, y: 0, scale: 1, duration: 0.55, ease: 'back.out(1.4)' }, '-=0.25')
          .to(infoCardRef.current, { opacity: 1, y: 0, duration: 0.5 }, '-=0.2')
          .to(mapEmbedRef.current, { opacity: 1, y: 0, duration: 0.55 }, '-=0.2');
    }, []);

    const handleOpenMaps = () => {
        window.open(
            'https://www.google.com/maps/place/El-Orouba,+Cairo+Governorate/@30.0939003,31.3394451,15z/data=!4m6!3m5!1s0x145815f69a821e87:0x78a85f1813fc9658!8m2!3d30.0973322!4d31.3460977!16s%2Fg%2F1tvdxr7t?entry=ttu&g_ep=EgoyMDI2MDUxMC4wIKXMDSoASAFQAw%3D%3D',
            '_blank',
            'noopener,noreferrer'
        );
    };

    return (
        <div className="home-wrapper">
            <div className="mobile-container">
                <div className="map-screen">

                    <AsteriskNav active="map" navRef={navRef} />

                    <main className="map-sheet" ref={sheetRef}>
                        <div className="hp-tab-indicator" aria-hidden="true"></div>

                        <section className="map-location-card" ref={locationCardRef} aria-labelledby="location-name">
                            <header className="map-location-header">
                                <span className="map-pin-icon" aria-hidden="true">
                                    <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                                        <circle cx="12" cy="10" r="3"/>
                                    </svg>
                                </span>
                                <h1 className="map-location-name" id="location-name">Cairo Exhibition Center</h1>
                            </header>
                            <address className="map-location-address">
                                El-Orouba St, Heliopolis, Nasr City, Cairo Governorate, Egypt
                            </address>

                            <div className="map-divider" aria-hidden="true"></div>

                            <div className="map-contact-row" ref={contactRowRef}>
                                <span className="map-contact-item">
                                    <svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.62 3.38 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.82a16 16 0 0 0 6 6l.97-.97a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.5 16z"/>
                                    </svg> <span className="sr-only">Phone: </span> +20 2 1234 5678
                                </span>
                                <span className="map-contact-item">
                                    <svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="2" y="4" width="20" height="16" rx="2"/>
                                        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                                    </svg> <span className="sr-only">Email: </span> info@cec.eg
                                </span>
                            </div>


                      
                        </section>

                        <section className="map-info-card" ref={infoCardRef} aria-labelledby="getting-there-title">
                            <div className="map-info-icon-wrap" aria-hidden="true">
                                <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="10"/>
                                    <line x1="12" y1="8" x2="12" y2="12"/>
                                    <line x1="12" y1="16" x2="12.01" y2="16"/>
                                </svg>
                            </div>
                            <div className="map-info-body">
                                <h2 className="map-info-title" id="getting-there-title">Getting There</h2>
                                <p className="map-info-desc">
                                    Free parking available. Accessible via Cairo Metro Line 3 (Airport Line) - Stadium Station.
                                </p>
                            </div>
                        </section>

                        <section className="map-embed-card" ref={mapEmbedRef} aria-label="Location map">
                            <div className="map-embed-header">
                                <span className="map-embed-label">
                                    <svg aria-hidden="true" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                                        <circle cx="12" cy="10" r="3"/>
                                    </svg>
                                    El-Orouba, Heliopolis
                                </span>
                                <span className="map-embed-live-dot" aria-hidden="true"></span>
                            </div>
                            <div className="map-embed-frame-wrap" onClick={handleOpenMaps} role="button" tabIndex={0} aria-label="Open location in Google Maps" onKeyDown={e => e.key === 'Enter' && handleOpenMaps()}>
                                <iframe
                                    title="Cairo Exhibition Center location map"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3452.2!2d31.3394451!3d30.0939003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x145815f69a821e87%3A0x78a85f1813fc9658!2sEl-Orouba%2C%20Cairo%20Governorate!5e0!3m2!1sen!2seg!4v1"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                                <div className="map-embed-overlay" aria-hidden="true">
                                    <span className="map-embed-open-hint">
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                                            <polyline points="15 3 21 3 21 9"/>
                                            <line x1="10" y1="14" x2="21" y2="3"/>
                                        </svg>
                                        Tap to open
                                    </span>
                                </div>
                            </div>
                        </section>

                    </main>
                </div>
            </div>
        </div>
    );
};

export default MapPage;